import {
  AuthBrandPanelStyled,
  AuthFeatureListStyled,
} from '@OnArk/styles/Auth.styled';

import React from 'react';

import Link from 'next/link';

import LogoSVG from '@OnArk/SVGs/Logo';

interface Feature {
  title: string;
  body: string;
}

// Marketing feature list — only shown on acquisition pages (login, sign-up).
// Transactional auth pages (forgot, reset, join, magic) pass no features and
// render just the headline + lede.
export const DEFAULT_AUTH_FEATURES: Feature[] = [
  {
    body: 'Match your branding, embed video, ask the questions that matter.',
    title: 'Build classes that feel like yours',
  },
  {
    body: 'Automate the follow-up so no guest slips through the cracks.',
    title: 'Connect to Planning Center',
  },
  {
    body: 'Real reports on check-ins, completions, and engagement.',
    title: "See what's working",
  },
];

export default function AuthBrandPanel({
  features,
  headline,
  lede,
}: {
  headline: string;
  lede: string;
  features?: Feature[];
}) {
  return (
    <AuthBrandPanelStyled>
      <div>
        <Link passHref href="/">
          <LogoSVG
            css={{ cursor: 'pointer', height: '4rem', width: 'auto' }}
            fill="#fff"
          />
        </Link>
        <div>
          <h1>{headline}</h1>
          <p className="lede">{lede}</p>
        </div>
        {features && features.length > 0 && (
          <AuthFeatureListStyled as="ul">
            {features.map(f => (
              <li key={f.title}>
                <figure>✓</figure>
                <div>
                  <h3>{f.title}</h3>
                  <p>{f.body}</p>
                </div>
              </li>
            ))}
          </AuthFeatureListStyled>
        )}
      </div>
    </AuthBrandPanelStyled>
  );
}
